import React, { useMemo } from 'react';
import { FaChartPie } from 'react-icons/fa';

const AppDistributionChart = ({ products, loading }) => {
    const appCounts = useMemo(() => {
        return products?.reduce((acc, product) => {
            acc[product.app] = (acc[product.app] || 0) + 1;
            return acc;
        }, {}) || {};
    }, [products]);

    const totalApps = Object.values(appCounts).reduce((sum, count) => sum + count, 0) || 1;
    
    // Color mapping for apps
    const appColors = {
        "pharmtrix-retail": "#3B82F6",
        "pharmtrix-wholesale": "#8B5CF6", 
        "labtrix": "#EC4899",
        "centrix": "#10B981",
        "billtrix": "#F59E0B"
    };

    if (loading) {
        return (
            <div className="bg-white rounded-xl shadow-sm p-5 h-full">
                <div className="animate-pulse">
                    <div className="h-5 bg-gray-200 rounded w-1/3 mb-6"></div>
                    <div className="space-y-5">
                        {[1, 2, 3].map(i => (
                            <div key={i} className="space-y-2">
                                <div className="flex justify-between">
                                    <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                                    <div className="h-4 bg-gray-200 rounded w-1/6"></div>
                                </div>
                                <div className="h-2 bg-gray-200 rounded w-full"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-xl shadow-sm p-5 h-full">
            <div className="flex justify-between items-center mb-5">
                <h3 className="text-lg font-semibold text-gray-800">App Distribution</h3>
                <div className="p-2 rounded-lg bg-blue-50">
                    <FaChartPie className="text-blue-500" />
                </div>
            </div>
            <div className="space-y-4">
                {Object.entries(appCounts).map(([app, count]) => {
                    const percent = Math.round((count / totalApps) * 100);
                    const color = appColors[app] || "#CBD5E1";
                    
                    return (
                        <div key={app} className="group">
                            <div className="flex justify-between mb-1">
                                <span className="text-sm font-medium text-gray-700">{app}</span>
                                <span className="text-sm font-semibold">
                                    {count} <span className="text-gray-500 font-normal">({percent}%)</span>
                                </span>
                            </div>
                            <div className="w-full bg-gray-100 rounded-full h-2.5 overflow-hidden">
                                <div 
                                    className="h-2.5 rounded-full transition-all duration-500 ease-out group-hover:opacity-80"
                                    style={{ width: `${percent}%`, backgroundColor: color }}
                                ></div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default AppDistributionChart; 